import { http, HttpResponse } from 'msw';

import { signer } from './fixture/agreements';

export const agreementsHandlers = [
  http.get('**/notarial/widget/signatures/:signatureRequestKey', () => HttpResponse.json(signer)),
];
